import React from "react";
import "../pagesstyles/aboutpages.css";
function Bookingg() {
  return (
    <>
      <div className="pageone">
        <div className="container">
          <div className="banner-content">
            <h1>Booking</h1>
            <div className="breadcrumb">
              <span><i class="fa-solid fa-house"></i> Home </span>
              <span className="separator">  /  </span>
              <span className="current"> Booking </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Bookingg;